import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SectionHeader from "../../components/sectionHeader/sectionHeader";
import Tabs from "../../components/tabs/tabs";
import PresupuestosProveedor from "./presupuestosProveedor/presupuestosProveedor";
import TiendasProveedor from "./tiendasProveedor/tiendasProveedor";
import GestionEspecialesProveedor from "./gestionEspecialesProveedor/gestionEspecialesProveedor";
import GestionEspeciales from "../dashboard/gestionPresupuestos/gestionEspeciales/gestionEspeciales";

export default function GestionPresupuestoProveedor({ user }) {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("presupuestosProveedor");

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const tabFromUrl = urlParams.get('activeTab');
        if (tabFromUrl) {
            setActiveTab(tabFromUrl);
        }
    }, [location.search]);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };

    // Determinar qué componente de especiales mostrar según el tipo de empresa
    const codTipoEmpresa = user?.codTipoEmpresa ?? user?.CodTipoEmpresa ?? user?.tipoEmpresa ?? user?.TipoEmpresa ?? null;
    const isProveedor = codTipoEmpresa === 3;

    return (
        <section className="dashboard-usuarios">
            <SectionHeader
                title="Panel de Administrador - Gestión de presupuestos"
                subtitle="Aquí puedes gestionar los presupuestos pendientes y consultar el histórico"
            />

            <Tabs
                tabs={[
                    { id: "presupuestosProveedor", label: "Presupuestos" },
                    { id: "mobiliarioEspecial", label: "Mobiliario especial" },
                    { id: "misTiendas", label: "Mis tiendas" },
                ]}
                activeTab={activeTab}
                onTabChange={handleTabChange}
            />

            <div className="dashboard-usuarios__content">
                {activeTab === "presupuestosProveedor" && (
                    <PresupuestosProveedor user={user} />
                )}

                {activeTab === "mobiliarioEspecial" && (
                    isProveedor ? (
                        <GestionEspecialesProveedor user={user} />
                    ) : (
                        <GestionEspeciales user={user} />
                    )
                )}

                {activeTab === "misTiendas" && <TiendasProveedor user={user} />}
            </div>
        </section>
    );
}